import { useSelector } from "react-redux";
 
import PageTopTitle from "../../components/shared/PageTopTitle";
import styled from "styled-components";
const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      gap: 60px;
      margin: 0 30px;
      margin-top: 20px;
      @media (max-width: 1550px) {
        margin: 0;
        padding: 20px 30px 0px;
        width: 100%;
        overflow: auto;
      }
    }
  }
`;

const SeferMaliyetKayitlari = () => {

  const titles = [
    "Üye Adı Soyadı",
    "Telefonu",
    "Plaka",
    "Araç Tipi",
    "Yakıt Tüketimi(%)",
    "Lastik Ömrü",
    "Lastik Fiyatı",
    "MTV",
    " Trafik Sigortası",
    "Muayene Harç Bedeli",
    "Akü Bedeli",
    "Akü Değişim Süresi(Ay)",
    "Aylık Arıza Bakım Onarım",
    "Araç Sahibi SGK-Bağkur",
    "Sürücü",
    "Sürücü Maaşı",
    "Sürücü Harcırah",
    "Günlük Yemek",
  ];

  const data = [
    {
      data1: "data1",
      data2: "data1",
      data3: "data1",
      data4: "data1",
      data5: "data1",
      data6: "data1",
      data7: "data1",
      data8: "data1",
      data9: "data1",
      data10: "data1",
      data11: "data1",
      data12: "data1",
      data13: "data1",
      data14: "data1",
      data15: "data1",
      data16: "data1",
      data17: "data1",
      data18: "data1",
      data19: "data1",
      data20: "data1",
      data21: "data1",
      data22: "data1",
    },
    {
      data1: "data2",
      data2: "data2",
      data3: "data2",
      data4: "data2",
      data5: "data2",
      data6: "data2",
      data7: "data2",
      data8: "data2",
      data9: "data2",
      data10: "data2",
      data11: "data2",
      data12: "data2",
      data13: "data2",
      data14: "data2",
      data15: "data2",
      data16: "data2",
      data17: "data2",
      data18: "data2",
      data19: "data2",
      data20: "data2",
      data21: "data2",
      data22: "data2",
    },
    {
      data1: "data3",
      data2: "data3",
      data3: "data3",
      data4: "data3",
      data5: "data3",
      data6: "data3",
      data7: "data3",
      data8: "data3",
      data9: "data3",
      data10: "data3",
      data11: "data3",
      data12: "data3",
      data13: "data3",
      data14: "data3",
      data15: "data3",
      data16: "data3",
      data17: "data3",
      data18: "data3",
      data19: "data3",
      data20: "data3",
      data21: "data3",
      data22: "data3",
    },
    {
      data1: "data4",
      data2: "data4",
      data3: "data4",
      data4: "data4",
      data5: "data4",
      data6: "data4",
      data7: "data4",
      data8: "data4",
      data9: "data4",
      data10: "data4",
      data11: "data4",
      data12: "data4",
      data13: "data4",
      data14: "data4",
      data15: "data4",
      data16: "data4",
      data17: "data4",
      data18: "data4",
      data19: "data4",
      data20: "data4",
      data21: "data4",
      data22: "data4",
    },
  ];

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Sefer Maliyet Kayıtları"} position="sticky" />
        <div className="content">
          
        </div>
      </div>
    </Container>
  );
};

export default SeferMaliyetKayitlari;
